import { FlyerLayoutAbstract } from './flyer-layout.abstract'
import moment from 'moment-timezone'

export default class Flyer_layout_split_t_039LayoutModel extends FlyerLayoutAbstract {
  flourishes = [
    {
      name: 'lines_balloon_flyer',
      left: 0,
      top: 0,
      width: 320,
      height: 568
    }
  ]

  textLayouts = {
    event_name_1: {
      top: 74,
      left: 14,
      size: 49,
      width: 292,
      height: 206,
      align: 'center'
    },
    location_1: {
      top: 430,
      left: 171,
      size: 13,
      width: 130,
      height: 15
    },
    location_2: {
      top: 451,
      left: 171,
      size: 12,
      width: 130,
      height: 21
    }
  }

  dateLayouts = {
    date_1: {
      top: 430,
      left: 17,
      daySize: 13,
      height: 16,
      width: 130,
      lineHeight: 10,
      transformOrigin: 'right top'
    },
    date_2: {
      top: 451,
      left: 17,
      daySize: 13,
      height: 69,
      width: 130,
      lineHeight: 10,
      transformOrigin: 'right top'
    }
  }

  constructor(flyerDesign, eventData) {
    super(flyerDesign, eventData)
    this.init()
  }

  dayShortSuffixForDate(date) {
    const d = moment(date).date()
    if (d > 3 && d < 21) return 'TH'
    switch (d % 10) {
      case 1: return 'ST'
      case 2: return 'ND'
      case 3: return 'RD'
      default: return 'TH'
    }
  }

  getDateTexts() {
    const startDate = this.eventData.starts_at
    const endDate = this.eventData.ends_at
    const timeZone = this.eventData.timezone || 'UTC'

    const { daySize, left, top, align, width, height, lineHeight } = this.dateLayouts.date_1

    const safeDate1Color = this.dateProps.date1Props?.color?.replace('0x', '#') || '#cccccc'
    const safeDate1Font = this.dateProps.date1Props?.font?.replace(/\s+/g, '-') || 'Arial'
    const safeDate2Color = this.dateProps.date2Props?.color?.replace('0x', '#') || '#cccccc'
    const safeDate2Font = this.dateProps.date2Props?.font?.replace(/\s+/g, '-') || 'Arial'

    let dates = []
    let textTop = top

    if (!startDate) return { type: 'date', dates }

    const formatDayWithSuffix = (date, timeZone) => {
      const m = moment.tz(date, timeZone)
      const day = m.format('D')
      const suffix = this.dayShortSuffixForDate(date)
      return `${m.format('ddd - MMM - ')}${day}${suffix}`
    }

    const formatTime = (date, timeZone) => {
      return moment.tz(date, timeZone).format('h:mma').replace(/PM/g, 'pm').replace(/AM/g, 'am')
    }

    if (endDate) {
      const isSameDay = moment.tz(startDate, timeZone).isSame(moment.tz(endDate, timeZone), 'day')
      if (isSameDay) {
        const dayStr = formatDayWithSuffix(startDate, timeZone)
        const startTime = formatTime(startDate, timeZone)
        const endTime = formatTime(endDate, timeZone)
        dates.push({
          text: dayStr,
          align,
          width,
          height,
          left,
          top: textTop,
          color: safeDate1Color,
          font: safeDate1Font,
          size: daySize
        })
        textTop += daySize + lineHeight
        dates.push({
          text: `${startTime} - ${endTime}`,
          align,
          width,
          height,
          left,
          top: textTop,
          color: safeDate2Color,
          font: safeDate2Font,
          size: daySize
        })
      } else {
        const startDayStr = formatDayWithSuffix(startDate, timeZone)
        const startTime = formatTime(startDate, timeZone)
        const startStr = `${startDayStr}\n${startTime}`

        const endDayStr = moment.tz(endDate, timeZone).format('MMM - D') + this.dayShortSuffixForDate(endDate) + ' - ' + formatTime(endDate, timeZone)

        dates.push({
          text: startStr,
          align,
          width,
          height,
          left,
          top: textTop,
          color: safeDate1Color,
          font: safeDate1Font,
          size: daySize
        })
        textTop += daySize + lineHeight
        dates.push({
          text: 'till',
          align,
          width,
          height,
          left,
          top: textTop,
          color: safeDate1Color,
          font: safeDate1Font,
          size: daySize
        })
        textTop += daySize + lineHeight
        dates.push({
          text: endDayStr,
          align,
          width,
          height,
          left,
          top: textTop,
          color: safeDate2Color,
          font: safeDate2Font,
          size: daySize
        })
      }
    } else {
      const dayStr = formatDayWithSuffix(startDate, timeZone)
      const timeStr = formatTime(startDate, timeZone)
      const dateStr = `${dayStr}\n${timeStr}`
      dates.push({
        text: dateStr,
        align,
        width,
        height,
        left,
        top: textTop,
        color: safeDate1Color,
        font: safeDate1Font,
        size: daySize
      })
    }

    return { type: 'date', dates }
  }
}
